/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo, useState } from 'react';
import { Select, SelectProps } from 'antd';

export const ScOption = Select.Option;

interface ScSelectBaseProps extends SelectProps {
    onChange?: (s: any) => void;
    className?: string;
}

const ScSelectBase = ({
    onChange,
    showSearch = false,
    className,
    ...props
}: ScSelectBaseProps) => {
    /**
     * Do hành vi bản mới nhất khi bật showSearch sẽ không tự động đóng dropdown lại khi click vô ô input
     * Cái này dùng để làm thao tác giống như bản v5
     */
    const [isOpen, setOpen] = useState(false);

    const handleChange = (s) => {
        onChange?.(s);
        setOpen(false);
    };

    const extraOpts = useMemo(() => {
        if (!showSearch) {
            return {
                showSearch: false,
            };
        }
        return {
            open: isOpen,
            onOpenChange: (s) => {
                if (!s) {
                    setOpen(s);
                }
            },
            onClick: () => {
                // click lại input thì toggle
                setOpen((prev) => !prev);
            },
            showSearch,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showSearch, isOpen]);

    return (
        <>
            <Select
                onChange={handleChange}
                {...extraOpts}
                {...props}
                className={`${className} sc-select-box`}
            >
                {props.children}
            </Select>
        </>
    );
};

export default ScSelectBase;
